import { render, staticRenderFns } from "./AdminManageOrgs.vue?vue&type=template&id=27752d2a"
import script from "./AdminManageOrgs.vue?vue&type=script&lang=js"
export * from "./AdminManageOrgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports